/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__badge__alternative = /** @type {(inputs: {}) => string} */ () => {
	return `Alternativ`
};

const en_route__badge__alternative = /** @type {(inputs: {}) => string} */ () => {
	return `Alternative`
};

const es_route__badge__alternative = /** @type {(inputs: {}) => string} */ () => {
	return `Alternativa`
};

const fr_route__badge__alternative = /** @type {(inputs: {}) => string} */ () => {
	return `Alternatif`
};

const it_route__badge__alternative = /** @type {(inputs: {}) => string} */ () => {
	return `Alternativo`
};

const nl_route__badge__alternative = /** @type {(inputs: {}) => string} */ () => {
	return `Alternatief`
};

const pt_route__badge__alternative = /** @type {(inputs: {}) => string} */ () => {
	return `Alternativo`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__alternative = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__badge__alternative(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__badge__alternative", locale)
	if (locale === "de") return de_route__badge__alternative(inputs)
	if (locale === "en") return en_route__badge__alternative(inputs)
	if (locale === "es") return es_route__badge__alternative(inputs)
	if (locale === "fr") return fr_route__badge__alternative(inputs)
	if (locale === "it") return it_route__badge__alternative(inputs)
	if (locale === "nl") return nl_route__badge__alternative(inputs)
	return pt_route__badge__alternative(inputs)
};